import React, { createContext, useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import {
  applyLanguage,
  getDirection,
  getLanguage,
  reprLabel,
  translate
} from './index';

const LanguageContext = createContext({
  language: getLanguage(),
  setLanguage: () => {}
});

applyLanguage(getLanguage());

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(getLanguage());

  const setLanguage = useCallback((next) => {
    setLanguageState(applyLanguage(next));
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

LanguageProvider.propTypes = {
  children: PropTypes.node
};

export const useTranslation = () => {
  const { language, setLanguage } = useContext(LanguageContext);
  const t = useCallback(
    (key, params) => translate(key, params, language),
    [language]
  );
  const repr = useCallback(
    (value, group) => reprLabel(value, group, language),
    [language]
  );
  const direction = getDirection(language);

  return {
    t,
    repr,
    language,
    setLanguage,
    direction,
    isRtl: direction === 'rtl'
  };
};
